// extracted by mini-css-extract-plugin
export default {"container":"gwVmh3vyfgLw5a6naZuI"};